// logic
window.addEventListener('load', function(){
 const nav = document.getElementById('kiosk-nav')
 const list = document.getElementById('kiosk-list')

  if (nav) {
    nav.addEventListener('click', function(e){
      const button = e.target;
      const [characterFrom, characterTo] = button.innerText.trim().toLowerCase().split('-');

      // remove active from all buttons
      [...nav.children].forEach((button)=> {
        button.classList.remove('active')
      })

      // add active to clicked button
      button.classList.add('active');

      // scroll to top
      // window.scrollTo({
      //   top: 170,
      //   behavior: 'smooth',
      // });

      // hide or show related kiosks
      [...list.children].forEach((item)=> {
        const title = item.getElementsByClassName('kiosk-tile-name')[0]
        const titleFirstCharacter = title.innerText[0].toLowerCase()
        
        item.classList.add('hidden')

        if (title) {
          if (titleFirstCharacter >= characterFrom && titleFirstCharacter <= characterTo) {
            item.classList.remove('hidden')
          }
        }
      })
    })

    // choose first button to filter by
    nav.children[0].click()
  }
})
